import * as BpmnAction from '../actions/bpmn.action'

// 初始化数据值
const initialState = {
  visible: false,
  info: {}
}


export function reducer(state = initialState, action: BpmnAction.BpmnAction) {

  let newState = JSON.parse(JSON.stringify(state));

  switch (action.type) {
    case BpmnAction.HIDE_NODE:
      newState.push(action.payload);
      return newState;
    case BpmnAction.SHOW_NODE:
      newState.push(action.payload);
      return newState;
    default:
      return state;
  }
}